import { render, staticRenderFns } from "./CustomDatePicker.vue?vue&type=template&id=163a7f1c"
import script from "./CustomDatePicker.vue?vue&type=script&lang=js"
export * from "./CustomDatePicker.vue?vue&type=script&lang=js"
import style0 from "./CustomDatePicker.vue?vue&type=style&index=0&id=163a7f1c&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports